import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-author-storyboard-popover',
  templateUrl: './author-storyboard-popover.component.html',
  styleUrls: ['./author-storyboard-popover.component.scss'],
})
export class AuthorStoryboardPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
